import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        horizontalDefault: {
            backgroundColor: 'border.light',
            height: remCalc(1),
            width: '100%',
        },
        verticalDefault: {
            backgroundColor: 'border.light',
            height: {base: remCalc(50), md: remCalc(70), lg: remCalc(80)},
            width: remCalc(1),
        },
    },
    parts: ['horizontalDefault', 'verticalDefault'],
}
